define('directives/bootstrap/bsModal',[
	"application",
	"bootstrap"
], function (app) {

	return app.directives.directive("bsModal", function () {

		return {
			restrict: "A",
			replace: true,
			template: "<div class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>\
							<div class='modal-dialog modal-sm'>\
								<div class='modal-content'>\
									<div class='modal-header'>\
										<button type='button' class='close' data-dismiss='modal' aria-hidden='true'>×</button>\
									</div>\
									<div class='modal-body'>\
										<div ng-transclude></div>\
									</div>\
									<div class='modal-footer'>\
										<button type='button' class='btn btn-sm btn-danger' data-dismiss='modal' ng-click='ok()'>Ok</button>\
										<button class='btn btn-sm btn-info' data-dismiss='modal' aria-hidden='true'>Cancel</button>\
									</div>\
								</div>\
							</div>\
						</div>",
			transclude: true,
			controller: function($scope) {
				$scope.ok = function() {
					if ($scope.okHandler) {
						$scope.okHandler();
					};
				};
			},
			scope: {
				okHandler: "&"
			}
		};

	});

});
